<div class="fr-page-content fr-page-content--fullCenter">
  <fr-error-base>
    <span title>500 Internal server error</span>
    <span description>There was an internal error and the action can't be completed.</span>
    <span url>URL: {{ errorUrl }}</span>
  </fr-error-base>
</div>
